import type { EntityConfig } from '../types'

export const eventsLogsEntity: EntityConfig = {
  id: 'eventsLogs',
  displayName: 'Events Logs',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'succeeded', label: 'Succeeded' },
      { value: 'processing', label: 'Processing' },
      { value: 'approved', label: 'Approved' },
      { value: 'verified', label: 'Verified' },
      { value: 'failed', label: 'Failed' },
      { value: 'pending', label: 'Pending' }
    ],
    options: [
      { value: 'succeeded', label: 'Succeeded', color: 'success' },
      { value: 'approved', label: 'Approved', color: 'success' },
      { value: 'verified', label: 'Verified', color: 'success' },
      { value: 'processing', label: 'Processing', color: 'pending' },
      { value: 'pending', label: 'Pending', color: 'pending' },
      { value: 'failed', label: 'Failed', color: 'error' }
    ],
    mappings: {
      all: ['succeeded', 'approved', 'verified', 'processing', 'pending', 'failed'],
      succeeded: ['succeeded'],
      processing: ['processing'],
      approved: ['approved'],
      verified: ['verified'],
      failed: ['failed'],
      pending: ['pending']
    }
  },
  queryFields: {},
  uiFilterFields: []
}
